import { render, staticRenderFns } from "./productSummary.vue?vue&type=template&id=6ab83e20&scoped=true&"
import script from "./productSummary.vue?vue&type=script&lang=js&"
export * from "./productSummary.vue?vue&type=script&lang=js&"
import style0 from "./productSummary.vue?vue&type=style&index=0&id=6ab83e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab83e20",
  null
  
)

export default component.exports